import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvioComprovanteDTO } from '../../dtos/envio-comprovante-dto';
import { AbstractServicePrivate } from '../../service/abstract.service.private';

@Injectable({
  providedIn: 'root'
})
export class EnvioComprovanteService extends AbstractServicePrivate {

  protected getBaseUrlPrivate(): string {

    return super.getBaseUrlPrivate() + 'envioComprovante';
  }

  procurarEnvioComprovantePorFiltro(filtro: EnvioComprovanteDTO): Observable<any> {

    return this.http.post(`${this.getBaseUrlPrivate()}/filtro`, filtro);
  }



}
